import { useEffect } from "react";
import { captureAttribution } from "@/lib/marketingAttribution";
import Footer from "@/components/sections/Footer";
import Navigation from "@/components/layout/Navigation";
import { useLocation } from "wouter";

interface RootLayoutProps {
  children: React.ReactNode;
}

function isLeadMagnetPath(path: string) {
  return path === "/ai-sales" || path === "/scorecard";
}

export default function RootLayout({ children }: RootLayoutProps) {
  const [location] = useLocation();
  useEffect(() => { if (!location.startsWith("/admin")) captureAttribution(); }, [location]);
  const isContactCard = location === "/rodolfo";
  const isPaymentPage = location.startsWith("/pay/");
  const isAdmin = location.startsWith("/admin");
  const isWorkspace = location.startsWith("/workspace");
  const isBrief = location === "/morning-brief" || location === "/brief";
  const isStandaloneForm =
    location === "/onboard"
    || location === "/start"
    || location === "/client-onboarding"
    || location.startsWith("/client-forms");
  const hideChrome = isContactCard || isPaymentPage || isAdmin || isWorkspace || isBrief || isStandaloneForm;
  const leadPage = isLeadMagnetPath(location);

  return (
    <div className={hideChrome ? "min-h-screen flex flex-col" : "mkt-page min-h-screen flex flex-col bg-[#F4F2EC] text-[#0B0B0B]"}>
      {!hideChrome && <Navigation />}
      <main className={hideChrome ? "flex-1" : "flex-1"}>
        {children}
      </main>
      {!hideChrome && !leadPage && <Footer />}
    </div>
  );
}
